import { AccountType } from "../class/destinationAccount";
import { TransferAccountType } from "../class/transferIntent";

const transformAccountTypeDisplayName = (accountType?: TransferAccountType | AccountType): string => {
  if (!accountType) return "account";
  switch (accountType) {
    case TransferAccountType.ANNUITY:
      return "Annuity account";
    case TransferAccountType.IRA:
    case TransferAccountType.ROTH_IRA:
    case AccountType.ira:
      return "Individual retirement account";
    case TransferAccountType.EMPLOYER_401k:
    case TransferAccountType.EMPLOYER_403b:
    case TransferAccountType.EMPLOYER_457:
    case AccountType.employerSponsored:
      return "Employer sponsored account";
    case TransferAccountType.SEP_IRA:
      return "SEP IRA";
    case TransferAccountType.SIMPLE_IRA:
      return "Simple IRA";

    default:
      return "account";
  }
};

export default transformAccountTypeDisplayName;
